import { Button, Stack, Typography } from '@mui/material'
import React, { useState } from 'react'
import CustomContainer from '../../components/common/CustomContainer'
import CustomTextField from '../../components/common/CustomTextField'
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks'
import { UserManager } from '../../services/api/UserManager'
import { displayMessage } from '../../services/redux/snackbar/snackbar-actions'
import LogoutDialog from './LogoutDialog'
import { getAuthState } from '../../services/redux/auth/auth-selectors'
import { getUserRoleName } from '../../utils/user-utils'

const Settings: React.FC = () => {
    const dispatch = useAppDispatch()
    const { role, userName } = useAppSelector(getAuthState)

    const [loadingData, setLoadingData] = useState<boolean>(false)
    const [oldPassword, setOldPassword] = useState<string>('')
    const [newPassword, setNewPassword] = useState<string>('')
    const [newPasswordAgain, setNewPasswordAgain] = useState<string>('')

    const handlePasswordChange = async () => {
        if (newPassword !== newPasswordAgain) {
            return dispatch(displayMessage({ message: 'Nová hesla se neshodují', type: 'error' }))
        }
        try {
            setLoadingData(true)
            const changedPassword = await UserManager.getManager().updatePasswordAsync(oldPassword, newPassword)
            if (changedPassword) {
                setOldPassword('')
                setNewPassword('')
                setNewPasswordAgain('')
                dispatch(displayMessage({ message: 'Změna hesla proběhla úspěšně', type: 'success' }))
            }
        } catch (error) {
            setLoadingData(false)
            return dispatch(displayMessage({ message: error, type: 'error' }))
        }
        setLoadingData(false)
    }

    return (
        <CustomContainer>
            <Stack direction='row' justifyContent='space-between'>
                <Typography variant='h5' mb={2} fontWeight={500}>{userName} - {getUserRoleName(role)}</Typography>

                <div>
                    <LogoutDialog />
                </div>
            </Stack>
            <Stack width='25%' spacing={2}>
                <Typography variant='h6'>Změna hesla</Typography>
                <CustomTextField
                    disabled={loadingData}
                    size='small'
                    label='Staré heslo'
                    type='password'
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && !loadingData) {
                            handlePasswordChange()
                        }
                    }}
                />
                <CustomTextField
                    disabled={loadingData}
                    size='small'
                    label='Nové heslo'
                    type='password'
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && !loadingData) {
                            handlePasswordChange()
                        }
                    }}
                />
                <CustomTextField
                    disabled={loadingData}
                    size='small'
                    label='Nové heslo znovu'
                    type='password'
                    value={newPasswordAgain}
                    onChange={(e) => setNewPasswordAgain(e.target.value)}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter' && !loadingData) {
                            handlePasswordChange()
                        }
                    }}
                />
                <Button disabled={loadingData} variant='contained' onClick={() => handlePasswordChange()}>
                    Změnit heslo
                </Button>
            </Stack>
            <Typography variant='body2' align='center'>
                Verze {process.env.REACT_APP_VERSION}
            </Typography>
        </CustomContainer>
    )
}

export default Settings
